const dialDialog = document.getElementById('dial-dialog');
function openDialog(dialog) { if (!dialog) return; dialog.showModal(); document.body.classList.add('dialog-open'); }
document.querySelectorAll('[data-open-dial]').forEach(button => button.addEventListener('click', () => openDialog(dialDialog)));
document.querySelectorAll('dialog').forEach(dialog => {
  dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => document.body.classList.remove('dialog-open'));
  dialog.addEventListener('click', event => {
    const box = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
  });
});
const mobileBar = document.querySelector('.mobile-bar');
let heroVisible = true;
let purchaseVisible = false;
const observer = new IntersectionObserver(entries => {
  for (const entry of entries) {
    if (entry.target.classList.contains('hero')) heroVisible = entry.isIntersecting;
    if (entry.target.id === 'your-slowko') purchaseVisible = entry.isIntersecting;
  }
  mobileBar.hidden = heroVisible || purchaseVisible;
});
observer.observe(document.querySelector('.hero'));
observer.observe(document.getElementById('your-slowko'));
